/* Paola & Joy — add-to-cart toast. Ink panel, Paper text, auto-dismiss. */
(function () {
  var TIMEOUT = 5000;
  var node = null;
  var timer = null;

  function build() {
    if (node) return node;
    node = document.createElement('div');
    node.className = 'pj-toast';
    node.setAttribute('role', 'status');
    node.setAttribute('aria-live', 'polite');
    node.innerHTML =
      '<span class="pj-toast__text" data-pj-toast-text></span>' +
      '<button type="button" class="pj-toast__link" data-pj-toast-bag>View bag</button>' +
      '<button type="button" class="pj-toast__close" aria-label="Dismiss" data-pj-toast-close>' +
      '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">' +
      '<path d="M1 1l10 10M11 1L1 11" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg></button>';
    document.body.appendChild(node);

    node.querySelector('[data-pj-toast-close]').addEventListener('click', hide);
    node.querySelector('[data-pj-toast-bag]').addEventListener('click', openBag);
    return node;
  }

  function openBag() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      hide();
      drawer.open();
      return;
    }
    window.location.href = (window.routes && window.routes.cart_url) || '/cart';
  }

  function hide() {
    if (!node) return;
    node.classList.remove('is-open');
    if (timer) { clearTimeout(timer); timer = null; }
  }

  function show(message, opts) {
    var el = build();
    el.querySelector('[data-pj-toast-text]').textContent = message;
    var bag = el.querySelector('[data-pj-toast-bag]');
    bag.textContent = (opts && opts.bagLabel) || 'View bag';
    bag.hidden = Boolean(opts && opts.hideBag);
    el.classList.add('is-open');
    if (timer) clearTimeout(timer);
    timer = setTimeout(hide, (opts && opts.timeout) || TIMEOUT);
  }

  /* Refresh the header bag count without a page load. */
  function refreshCartCount() {
    return fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', {
      headers: { 'Content-Type': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        var icon = document.querySelector('#cart-icon-bubble');
        if (icon && !icon.querySelector('.cart-count-bubble') && cart.item_count > 0) {
          window.location.reload();
        }
        document.dispatchEvent(new CustomEvent('pj:cart:updated', { detail: cart }));
        return cart;
      })
      .catch(function () { /* count refresh is best-effort */ });
  }

  window.PJToast = { show: show, hide: hide, refreshCartCount: refreshCartCount };
})();
